import { Controller } from '@hotwired/stimulus';

// A wait on money, polled on our own record, never the bank: the frame it
// sits in asks `url` again until the answer comes back with no poll inside
// it (paid, given up), and this one is gone with the old children.
//
//   <turbo-frame id="sale">
//     <div data-controller="poll" data-poll-url-value="/shop?sale=1"> the code, the wait </div>
//   </turbo-frame>
//
// 3 s, then x1.5 up to 15 s; nothing while the tab is hidden, and one ask the
// moment it shows again. The element lives inside the frame, which Turbo
// keeps while it swaps the children: the pace rides on the frame. qir's pix
// wait (walk/PAY.md 3 § wait, the Loja's sale) and merc's till (docs/TILL.md § Pix).
export default class extends Controller {
  static values = { url: String, ms: { type: Number, default: 3000 } };

  connect() {
    this.frame = this.element.closest('turbo-frame');
    if (!this.frame || !this.urlValue) return;
    this.onVisible = () => document.hidden || this.#ask();
    document.addEventListener('visibilitychange', this.onVisible);
    this.#next();
  }

  disconnect() {
    clearTimeout(this.timer);
    if (this.onVisible) document.removeEventListener('visibilitychange', this.onVisible);
  }

  get #delay() {
    return Number(this.frame.dataset.pollMs) || this.msValue;
  }

  #next() {
    clearTimeout(this.timer);
    this.timer = setTimeout(() => document.hidden || this.#ask(), this.#delay);
  }

  // A frame drawn with the page has no src, and reload() of none fetches
  // nothing: the first ask names it, every later one reloads it.
  #ask() {
    this.frame.dataset.pollMs = Math.min(this.#delay * 1.5, 15000);
    if (this.frame.src) this.frame.reload();
    else this.frame.src = this.urlValue;
    this.#next();
  }
}
